import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConfettiIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Confetti",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.857 11.443c.631 0 1.143-.51 1.143-1.143V5.73a1.143 1.143 0 1 0-2.286 0V10.3c0 .632.512 1.143 1.143 1.143M26.29 24h-4.572a1.142 1.142 0 1 0 0 2.286h4.571a1.142 1.142 0 1 0 0-2.286M16.917 10.986a1.14 1.14 0 0 0 1.518-.553l2.644-5.67a1.143 1.143 0 0 0-2.071-.967l-2.644 5.67a1.143 1.143 0 0 0 .553 1.52M30.4 9.182a1.143 1.143 0 0 0-1.616 0c-.47.465-.97.451-2.079.296-1.136-.156-2.692-.375-4.01.944s-1.102 2.874-.944 4.01c.154 1.112.171 1.612-.297 2.08-.465.465-.965.45-2.075.293-1.136-.16-2.69-.376-4.007.94a1.143 1.143 0 1 0 1.616 1.617c.465-.465.966-.449 2.075-.294 1.137.162 2.69.378 4.007-.94 1.318-1.319 1.103-2.875.944-4.01-.154-1.112-.17-1.612.297-2.08s.97-.45 2.08-.297c1.136.159 2.69.374 4.009-.943a1.143 1.143 0 0 0 0-1.616M7.724 14.59a1.15 1.15 0 0 0-1.051-.31c-.38.084-.692.354-.828.72l-1.61 4.323v.002L.09 30.452a1.142 1.142 0 0 0 1.47 1.47l15.452-5.756a1.144 1.144 0 0 0 .41-1.879zm-2.246 7.945 2.329 4.62-4.703 1.753zm4.484 3.818-3.397-6.74.801-2.15 7.18 7.182zM12.571 14.286c.946 0 1.715-.77 1.715-1.714s-.77-1.715-1.715-1.715-1.714.77-1.714 1.715.77 1.714 1.714 1.714M26.286 4C27.23 4 28 3.231 28 2.286S27.231.572 26.286.572s-1.715.769-1.715 1.714S25.341 4 26.286 4M28.571 17.143c-.945 0-1.714.77-1.714 1.714s.77 1.715 1.714 1.715 1.715-.77 1.715-1.715-.77-1.714-1.715-1.714"
    })
  }));
};
ConfettiIcon.displayName = 'ConfettiIcon';